// extracted by mini-css-extract-plugin
export var field = "contact-form-module--field--NDBvH";
export var headline = "contact-form-module--headline--wrWLn";
export var subHeadline = "contact-form-module--sub-headline--NOB+J";
export var submitButton = "contact-form-module--submit-button--VoiuW";
export var wrapper = "contact-form-module--wrapper--jmG5j";